import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class PageProjects extends Component {
  	
  	constructor(){
		super()
		this.state = {
			open: 		false,
			cat: 		'View All',
			transition: false,
			maxHeight: 	0,
		}
		this.handleResize 		= this.handleResize.bind(this);
		this.handleToggle 		= this.handleToggle.bind(this);
		this.handleCatChange 	= this.handleCatChange.bind(this);
	}
    
	componentDidMount() {
		
	  	window.addEventListener('resize', this.handleResize);
	}	
	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_evt) {
	    _evt.preventDefault();  
	    if (this.state.open === true) {
	    	this.setState({ open : false});
	    } else {
		    this.setState({ open : true});
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
    
    handleCatChange(evt) { 
		evt.preventDefault();   
		let text = evt.currentTarget.innerHTML
		this.setState({ transition : true });
		setTimeout(() => {
			this.setState({ cat : text, transition : false });
		}, 550);
	    
    }
        
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	
  	render () {
		
		let block = this.props.block;
				
		if (block) {
			
			let proClass = 'c-projects';
			if (this.state.transition === true) {
				proClass = proClass + ' state-hide';
			}
			
			if (block.types) {
									
			    return (
				    
				    <div id={block.id} className={'c-page__block c-page__block--' + block.bg_color}>
				    
				    	<div className="c-page__block__inner c-page__block__inner--small-margins">
				    		
				    		{block.heading && !block.text &&
				    			<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:'<h2>' + block.heading + '</h2>'}}></div>
			    			}
			    			
				    		<div className={proClass}>
				    		
				    			<div className={'c-projects__filters ' + (this.state.open ? 'state-open' : "")}>
									<a href="#" onClick={this.handleToggle} className="c-projects__filters__text" dangerouslySetInnerHTML={ {__html:'<span>Filter</span><span>Project Type</span>'}}></a>
									<div className="c-projects__filters__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
										<div className="c-projects__filters__body__inner" ref={e => (this.accordionBodyInner = e)}>
											<div className="c-projects__filters__nav">
												{block.types.map((type,i) =>
													{
														if (this.state.cat === type) {
															return (
																<a href="#" className="c-projects__filters__link state-active" dangerouslySetInnerHTML={ {__html:type}} key={i}></a>
															)
														} else {
															return (
																<a href="#" className="c-projects__filters__link" dangerouslySetInnerHTML={ {__html:type}} key={i} onClick={this.handleCatChange}></a>
															)
														}
													}
												)}
												{this.state.cat === 'View All' &&
													<a href="#" className="c-projects__filters__link state-active" dangerouslySetInnerHTML={ {__html:'View All'}}></a>
												}
												{this.state.cat !== 'View All' &&
													<a href="#" className="c-projects__filters__link" dangerouslySetInnerHTML={ {__html:'View All'}} onClick={this.handleCatChange}></a>
												}
											</div>
										</div>
									</div>
								</div>
				    		
				    			{block.project.map((project,i) =>
									{	
										if (project.type.indexOf(this.state.cat) !== -1 || this.state.cat === 'View All') {
											
											if (project.do_link === 'link') {
												
												if (project.url.indexOf('http') === -1) {
													
													return (
														
														<div className="c-projects__item" key={i}>
															<Link to={{ pathname: project.url }} className="c-projects__item__inner">
																
																{project.src &&
																	<div className="c-projects__item__image">
																		<Image srcset={project.srcset} src={project.src} />
																		<div className="c-projects__item__image__overlay">
																			<p className="c-projects__item__image__overlay__text" dangerouslySetInnerHTML={{__html:project.heading + '<br/>' + project.status}}></p>
																		</div>
																	</div>
																}
																{!project.src &&
																	<div className="c-projects__item__image c-projects__item__image--empty">
																		<div className="c-projects__item__image__logo"></div>
																	</div>
																}
																{project.heading &&
																	<h3 className="c-projects__item__heading" dangerouslySetInnerHTML={{__html:project.heading}}></h3>
																}
																{project.type &&
																	<h4 className="c-projects__item__type" dangerouslySetInnerHTML={{__html:project.type}}></h4>
																}
																
															</Link>
														</div>
													
													)
													
												} else {
													
													return (
														
														<div className="c-projects__item" key={i}>
															<a href={project.url} target="_blank" className="c-projects__item__inner">
																
																{project.src &&
																	<div className="c-projects__item__image">
																		<Image srcset={project.srcset} src={project.src} />
																		<div className="c-projects__item__image__overlay">
																			<p className="c-projects__item__image__overlay__text" dangerouslySetInnerHTML={{__html:project.heading + '<br/>' + project.status}}></p>
																		</div>
																	</div>
																}
																{!project.src &&
																	<div className="c-projects__item__image c-projects__item__image--empty">
																		<div className="c-projects__item__image__logo"></div>
																	</div>
																}
																{project.heading &&
																	<h3 className="c-projects__item__heading" dangerouslySetInnerHTML={{__html:project.heading}}></h3>
																}
																{project.type &&
																	<h4 className="c-projects__item__type" dangerouslySetInnerHTML={{__html:project.type}}></h4>
																}
																
															</a>
														</div>
													
													)
												}
												
											} else if (project.do_link === true) {
											
												return (
													<div className="c-projects__item" key={i}>
														<Link to={{ pathname: project.url }} className="c-projects__item__inner">
															
															{project.src &&
																<div className="c-projects__item__image">
																	<Image srcset={project.srcset} src={project.src} />
																	<div className="c-projects__item__image__overlay">
																		<p className="c-projects__item__image__overlay__text" dangerouslySetInnerHTML={{__html:project.heading + '<br/>' + project.status}}></p>
																	</div>
																</div>
															}
															{!project.src &&
																<div className="c-projects__item__image c-projects__item__image--empty">
																	<div className="c-projects__item__image__logo"></div>
																</div>
															}
															{project.heading &&
																<h3 className="c-projects__item__heading" dangerouslySetInnerHTML={{__html:project.heading}}></h3>
															}
															{project.type &&
																<h4 className="c-projects__item__type" dangerouslySetInnerHTML={{__html:project.type}}></h4>
															}
															
														</Link>
													</div>
												)
											
											} else {
												
												return (
													<div className="c-projects__item" key={i}>
														<div className="c-projects__item__inner">
															
															{project.src &&
																<div className="c-projects__item__image">
																	<Image srcset={project.srcset} src={project.src} />
																	<div className="c-projects__item__image__overlay">
																		<p className="c-projects__item__image__overlay__text" dangerouslySetInnerHTML={{__html:project.heading + '<br/>' + project.status}}></p>
																	</div>
																</div>
															}
															{!project.src &&
																<div className="c-projects__item__image c-projects__item__image--empty">
																	<div className="c-projects__item__image__logo"></div>
																</div>
															}
															{project.heading &&
																<h3 className="c-projects__item__heading" dangerouslySetInnerHTML={{__html:project.heading}}></h3>
															}
															{project.type &&
																<h4 className="c-projects__item__type" dangerouslySetInnerHTML={{__html:project.type}}></h4>
															}
															
														</div>
													</div>
												)
												
											}
										}
									}
								)}
				    			
				    		</div>
				    		
				    					    		
				    	</div>
				    					    
				    </div>
				)
				
			} else {
				
				return null;
				
			}
			
		} else {
			
			return null;
		
		}
	}
							
}